import React from 'react';

import { Progress } from '@gerdau/hefesto';
import useCountDown from '../utils/useCountDown';
import ExpiredOrder from '../ExpiredOrder';
import {
  Container,
  Counter,
  Description,
  ItemText,
  ProgressContainer
} from './styles';

export interface CountDownProgressProps {
  startTime: Date;
  endTime: Date;
}

const CountDownProgress = ({ startTime, endTime }: CountDownProgressProps) => {
  const { percent, text } = useCountDown({
    startTime,
    endTime
  });
  const complete = 100;
  let modalComponent;

  if (percent === complete) {
    modalComponent = <ExpiredOrder />;
  }

  return (
    <Container>
      {modalComponent}
      <ItemText>Tempo limite para finalizar o pedido</ItemText>
      <ProgressContainer>
        <Progress
          percentNumber={percent}
          showPercentNumber={false}
          {...(percent >= 100 && { error: true })}
        />
        <Counter>{text}</Counter>
      </ProgressContainer>
      <Description>
        Seu pedido ficará salvo durante este tempo, mas isso não garante a
        disponibilidade dos produtos.
        <br /> Finalize o pedido para evitar que ele expire.
      </Description>
    </Container>
  );
};

export default CountDownProgress;
